import { useEffect } from "react";




const LOGO_COLORS = ["#263012","#263012","#111111","#1d240e","#263012","#263012","#2a2a2a","#5c774a","#263012","#6b7280"];

function companyColor(n){
  return LOGO_COLORS[(n || "?").charCodeAt(0) % LOGO_COLORS.length];
}

export default function JobModal({ job, onClose, savedJobs, appliedJobs, applyingJobId, onToggleSave, onApplyClick }){
  const isSaved    = savedJobs.has(job.id);
  const isApplied  = appliedJobs.has(job.id);
  const isApplying = applyingJobId===job.id;
  const color      = companyColor(job.company);

  useEffect(()=>{
    const fn=e=>{ if(e.key==="Escape") onClose(); };
    window.addEventListener("keydown",fn);
    return()=>window.removeEventListener("keydown",fn);
  },[onClose]);

  return(
    <div className="jp-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="jp-modal" role="dialog" aria-modal="true">
        <div className="jp-modal__head" style={{"--acc":color}}>
          <div className="jp-modal__logo" style={{background:`${color}15`,borderColor:`${color}30`}}>
            {job.logo
              ? <img src={job.logo} alt={job.company} style={{width:"100%",height:"100%",objectFit:"contain",borderRadius:"inherit"}}/>
              : <span style={{color,fontWeight:900,fontSize:"1.3rem"}}>{(job.company||"?")[0]}</span>}
          </div>
          <div className="jp-modal__head-text">
            <div className="jp-modal__title">{job.title}</div>
            <div className="jp-modal__company">{job.company}</div>
          </div>
          <button className="jp-modal__close" onClick={onClose}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="16" height="16">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
        <div className="jp-modal__body">
          <div className="jp-modal__chips">
            <span className="jp-meta-chip jp-meta-chip--dept" style={{color,background:`${color}12`}}>{job.dept}</span>
            <span className="jp-meta-chip jp-meta-chip--type">{job.type}</span>
            {job.location&&<span className="jp-meta-chip jp-meta-chip--loc">📍 {job.location}</span>}
            {job.experience&&<span className="jp-meta-chip jp-meta-chip--exp">{job.experience}</span>}
            {job.locationType!=="On-site"&&<span className="jp-meta-chip">{job.locationType}</span>}
          </div>
          <div className="jp-modal__meta-row">
            <div className="jp-modal__meta-item">
              <div className="jp-modal__meta-icon" style={{background:color+"18",color}}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
              </div>
              <div>
                <div className="jp-modal__meta-label">Vacancies</div>
                <div className="jp-modal__meta-val" style={{color}}>{job.openings===1?"1 opening":`${job.openings} openings`}</div>
              </div>
            </div>
            {job.salary!=="Not disclosed"&&(
              <div className="jp-modal__meta-item">
                <div className="jp-modal__meta-icon" style={{background:"#f0fdf4",color:"#16a34a"}}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
                    <line x1="12" y1="1" x2="12" y2="23"/>
                    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
                  </svg>
                </div>
                <div>
                  <div className="jp-modal__meta-label">Salary</div>
                  <div className="jp-modal__meta-val" style={{color:"#16a34a"}}>{job.salary}</div>
                </div>
              </div>
            )}
            {job.postedLabel&&(
              <div className="jp-modal__meta-item">
                <div className="jp-modal__meta-icon" style={{background:"#f0f0f8",color:"#6b7280"}}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
                    <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
                  </svg>
                </div>
                <div>
                  <div className="jp-modal__meta-label">Posted</div>
                  <div className="jp-modal__meta-val">{job.postedLabel}{job.isNew&&<span className="jp-modal__new-badge">NEW</span>}</div>
                </div>
              </div>
            )}
          </div>
          {job.description&&(
            <div className="jp-modal__section">
              <div className="jp-modal__section-title">About this role</div>
              <div className="jp-modal__desc">{job.description}</div>
            </div>
          )}
          {job.tags.length>0&&(
            <div className="jp-modal__section">
              <div className="jp-modal__section-title">Skills &amp; Technologies</div>
              <div className="jp-modal__tags">{job.tags.map((t,i)=><span key={i} className="jp-tag">{t}</span>)}</div>
            </div>
          )}
        </div>
        <div className="jp-modal__footer">
          {isApplied ? (
            <button className="jp-btn jp-btn--applied" disabled>✓ Already Applied</button>
          ) : isApplying ? (
            <button className="jp-btn jp-btn--primary" disabled style={{opacity:0.75}}>
              <span className="jpc__spinner" style={{marginRight:6}}/>Applying…
            </button>
          ) : (
            <button className="jp-btn jp-btn--primary" onClick={()=>{onClose();onApplyClick(job);}}>
              Apply Now →
            </button>
          )}
          <button
            className={`jp-icon-btn${isSaved?" jp-icon-btn--saved":""}`}
            style={isSaved?{color,borderColor:color,background:`${color}12`}:{}}
            onClick={()=>onToggleSave(job)}
            title={isSaved?"Remove saved":"Save job"}>
            <svg viewBox="0 0 24 24" fill={isSaved?"currentColor":"none"} stroke="currentColor" strokeWidth="2">
              <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>
            </svg>
          </button>
          <button className="jp-btn jp-btn--ghost" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}